export default {
    defaultLanguage: 'en',
    languages: ['en', 'fr', 'nl', 'es'],
};
